var _path;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgMenos = function SvgMenos(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 30C14.0633 30 12.2433 29.6323 10.54 28.8968C8.83667 28.1623 7.355 27.165 6.095 25.905C4.835 24.645 3.83773 23.1633 3.1032 21.46C2.36773 19.7567 2 17.9367 2 16C2 14.0633 2.36773 12.2433 3.1032 10.54C3.83773 8.83667 4.835 7.355 6.095 6.095C7.355 4.835 8.83667 3.83727 10.54 3.1018C12.2433 2.36727 14.0633 2 16 2C17.9367 2 19.7567 2.36727 21.46 3.1018C23.1633 3.83727 24.645 4.835 25.905 6.095C27.165 7.355 28.1623 8.83667 28.8968 10.54C29.6323 12.2433 30 14.0633 30 16C30 17.9367 29.6323 19.7567 28.8968 21.46C28.1623 23.1633 27.165 24.645 25.905 25.905C24.645 27.165 23.1633 28.1623 21.46 28.8968C19.7567 29.6323 17.9367 30 16 30ZM10.5 14.5C9.67157 14.5 9 15.1716 9 16C9 16.8284 9.67157 17.5 10.5 17.5H21.5C22.3284 17.5 23 16.8284 23 16C23 15.1716 22.3284 14.5 21.5 14.5H10.5Z",
    fill: "#0A0A0A"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenos, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menos.352308dd.svg";
export { ForwardRef as ReactComponent };